import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-globe",
  templateUrl: "./globe.component.html",
  styleUrls: ["./globe.component.scss"],
})
export class GlobeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
